export default "/kiban/_next/static/images/korea-1babd230bee1dcb7cc83481aa49335e0.png";